import { Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { DialogContainer, DialogBody, CustomButton } from '../../../../common/components';

const AllotmentPlanDialog = ({ open, onClose, title, imageUrl }) => {
  return (
    <DialogContainer open={open} onClose={onClose} size="fullWidth" minHeight="90vh" maxWidth={false}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 3,
          pt: 2,
        }}
      >
        <Typography variant="h6" fontWeight={700}>
          {title || 'Plano del loteo'}
        </Typography>
        <IconButton onClick={onClose} aria-label="Cerrar">
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogBody sx={{ p: 2 }}>
        <Box
          component="img"
          alt={title || 'Plano del loteo'}
          src={imageUrl}
          sx={{
            width: '100%',
            height: 'auto',
            maxHeight: { xs: '70vh', sm: '75vh' },
            objectFit: 'contain',
            borderRadius: 1,
            backgroundColor: 'grey.50',
          }}
        />
      </DialogBody>

      <Box sx={{ display: 'flex', justifyContent: 'center', pb: 2 }}>
        <CustomButton onClick={onClose} variant="danger">
          Cerrar
        </CustomButton>
      </Box>
    </DialogContainer>
  );
};

export default AllotmentPlanDialog;
